import { render, staticRenderFns } from "./DataloggerView.vue?vue&type=template&id=135f61ea&lang=true"
import script from "./DataloggerView.vue?vue&type=script&lang=js"
export * from "./DataloggerView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports